// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] || chunkId) + "." + {"213":"a2b8077f","231":"fae066f0","239":"66bf2c92","453":"9a97f18d","732":"c81d8478","824":"50d70a50"}[chunkId] + ".chunk.js";
};